export default {
  NOTICE_INIT: (state, notices) => {
    state.notices = notices;
  },
  // saveNotices: (state, notices) => {
  //   state.notices = notices;
  // },
  ADD_NOTICE: (state, notice) => {
    let obj = state.notices.find(el => el.noticeId === notice.noticeId);
    if(!obj)
      state.notices.unshift(notice);
  },
  DELETE_NOTICE: (state, {noticeId}) => {
    let idx = state.notices.findIndex(el => el.noticeId === noticeId);
    if(idx < 0) 
      return;
    state.notices.splice(idx, 1);
  },
  DELETE_NOTICE_BY_FILE_ID: (state, {roomFileId}) => {
    let idx = state.notices.findIndex(el => el.roomFileId === roomFileId);
    if(idx < 0)
      return;
    state.notices.splice(idx, 1);
  },
  SET_NOTICE_FIX: (state, noticeInfo) => {
    let obj = state.notices.find(el => el.noticeId === noticeInfo.noticeId);
    if(!obj){
      console.warn('notice obj is null', noticeInfo);
      return;
    }
    if(noticeInfo.fixed == true){
      state.notices = state.notices.map(el => {
        el.fixed = false;
        return el;
      })
      noticeInfo.fixed = true;
    }
    obj.fixed = noticeInfo.fixed;
  },
};
